<template lang="pug">
    #freights.right-panel.md-elevation-1.md-scrollbar.md-theme-default
        .md-layout-row.header
            .md-flex
                .md-body-1
                    .md-layout
                        .md-layout-item
                            md-button.md-primary(v-bind:to="{name: 'StorekeepersFreights'}") Отмена
                        .md-layout-item.md-layout.md-alignment-top-right
                          md-button.md-primary(v-on:click="capture()" v-if="freight && freight.id") Подписать
                        .md-layout-item.md-layout.md-alignment-top-right(
                            v-if="!freightErrors.length && form.freight_id && debt && debt.result && (parseInt(freight.status_id) !== parseInt(issuedStatus.id))"
                        )
                            md-button.md-accent(v-on:click="issue()") Выдать


                    .md-caption.debt
                        .allow(v-if="debt && debt.result") Отгрузка разрешена
                        .deny(v-if="!debt || (debt && !debt.result)") Отгрузка запрещена

                    .errors(v-if="freightErrors && freightErrors.length")
                        .error(v-for="error in freightErrors") {{error}}
                    .error( v-if="parseInt(freight.status_id) === parseInt(issuedStatus.id)" ) Груз уже выдан клиенту


                    md-field(v-bind:class="{ 'md-invalid': errors.has('tracking') }")
                        label Номер отслеживания груза*
                        md-input(v-model="tracking" name="tracking" ref="tracking")

                    md-field(v-bind:class="{ 'md-invalid': errors.has('from_stock_id') }" v-show="freightsStatuses && freightsStatuses.length > 1")
                        label Статус груза
                        md-select(v-model="form.status_id" id="status_id" name="status_id" v-validate="'required|numeric'" data-vv-as=" ")
                            md-option(v-for="status in freightsStatuses" v-bind:key="status.id" v-bind:value="status.id") {{status.name}}
                        span.md-error(v-show="errors.has('status_id')") {{ errors.first('status_id') }}

                    md-field(v-if="freight && freight.id" v-show="freight.to_signature" v-bind:class="{ 'md-invalid': errors.has('to_signature'), 'md-has-value': !!freight.to_signature }")
                      label Подпись получателя
                      wacom-signature(ref="signature" v-model="freight.to_signature" v-on:capture-complete="onCapture" v-on:capture-cancel="onCaptureCancel")

                    div(v-if="freight && freight.id")
                        display-value(v-bind:inline="true" v-bind:value="(freight.traking_number)" v-bind:label="'Номер отслеживания'")
                        display-value(v-bind:inline="true" v-bind:value="((freight.status_id) ? freight.status.name : 'Не установлен')" v-bind:label="'Статус'")
                        display-value(v-bind:inline="true" v-bind:value="(freight.weight + ' кг.')" v-bind:label="'Вес'")
                        display-value(v-bind:inline="true" v-bind:value="((freight.departure_date) ? moment(freight.departure_date, 'YYYY-MM-DD HH:ss:mm').format('Do MMMM YYYY (DD.MM.YYYY)') : 'Не установленна')" v-bind:label="'Дата забора'")
                        display-value(v-bind:inline="true" v-bind:value="(freight.size + ' ' + freight.size_units + '.')" v-bind:label="'Объём'")
                        display-value(v-bind:inline="true" v-bind:value="((freight.doom) ? 'Да' : 'Нет')" v-bind:label="'Обрешётка'")
                        display-value(v-bind:inline="true" v-bind:value="(freight.price + ' руб.')" v-bind:label="'Цена'")
                        display-value(v-bind:inline="true" v-bind:value="((freight.factory_package) ? 'Да' : 'Нет')" v-bind:label="'Заводская упаковка'")
                        display-value(v-bind:inline="true" v-bind:value="((freight.oversized) ? 'Да' : 'Нет')" v-bind:label="'Негабаритный груз'")
                        display-value(v-bind:inline="true" v-bind:value="((freight.seats_number) ? freight.seats_number : 'Не установленно')" v-bind:label="'Количество мест'")
                        display-value(v-bind:inline="true" v-bind:value="((freight.forwarder_id) ? freight.forwarder.login : 'Не установлен')" v-bind:label="'Ответственный экспедитор'")
                        display-value(v-bind:inline="true" v-bind:value="((freight.description) ? freight.description : 'Не установленно')" v-bind:label="'Описание'")

                    toggle-card(v-if="freight && freight.deal && freight.deal.id && freight.deal.recipient_id" class="recipient-card" v-bind:visibility="showRecipient" heading="Данные получателя")
                        recipient(ref="recipient" v-bind:id="parseInt(freight.deal.recipient_id)" v-bind:deal_id="parseInt(freight.deal.id)")
</template>
<script>
    import moment from "moment";
    import DisplayValue from "@/components/DisplayValue";
    import WacomSignature from '@/components/WacomSignature';
    import recipient from './forms/recipient.vue';
    import ToggleCard from '@/components/ToggleCard';

    export default {
        components: {DisplayValue, WacomSignature, ToggleCard, recipient},
        metaInfo() {
            return {title: 'Выдача груза'}
        },
        data() {
            return {
                title: 'Выдача груза',
                loading: false,
                tracking: '',
                freight: {},
                issuedStatus: {},
                currentTracking: {},
                freightErrors: [],
                showRecipient: true,
                debt: {},
                form: {
                    freight_id:     null,
                    status_id:      null,
                    stock_id:       null,
                    responsible_id: null,
                    date: moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
                }
            }
        },
        watch: {
            '$route.params.id'() {
                this.init();
            },
            'tracking'(tracking) {
                setTimeout(() => {
                    if ((tracking.indexOf('/')+1)) this.tracking = tracking.split('/')[0];
                    this.getFreight();
                }, 300);
            },
            'freightsStatuses'() {
                this.$nextTick(() => this.setDefaultTrackingStatus());
            },
            'freight'(freight) {
                if (freight && freight.id) this.checkDebt();
            },
            'user'() {
                if (this.user && this.user.id) this.form.responsible_id = this.user.id;
            }
        },
        computed: {
            user() {
                if (!this.$store.state.users.current || !this.$store.state.users.current.id) return;
                return this.$store.state.users.current;
            },
            storeFreight() {
                return this.$store.state.storekeepers_stocks.freight;
            },
            freightsStatuses() {
                return this.$store.state.storekeepers_stocks.freight_statuses;
            },
            endpoint() {
                return this.$store.state.endpoint;
            },
        },
        methods: {
            capture() {
              return new Promise((resolve, reject) => {
                this.$refs.signature.$emit('capture');
                this.$on('onCapture', () => {
                  resolve();
                });
                this.$on('onCaptureCancel', () => {
                  if (reject) reject();
                });
              });
            },
            onCaptureCancel() {
              this.$emit('onCaptureCancel');
            },
            onCapture() {
                this.$nextTick(() => {
                    this.doCapture().then(() => this.$emit('onCapture'));
                });
            },
            doCapture() {
                let data = {
                    deal_id: this.freight.deal_id,
                    type: 'to_signature',
                    signature: this.freight.to_signature,
                    signature_all_freight: true
                };
                this.$store.commit('showProgressBar', 'load-storekeeper-freight-card');
                return this.$store.dispatch('deals/setDealCapture', data).finally(() => {
                    this.$store.commit('showSnackbar', ['Груз и заявка успешно подписаны', 6000, 'success']);
                    this.$store.commit('hideProgressBar', 'load-storekeeper-freight-card');
                });
            },
            init() {
                this.$store.commit('openRightPanel');
            },
            getFreight() {
                if (!this.tracking || (this.tracking && this.tracking.length < 13)) return;
                this.freight = {};
                this.loading = true;
                this.$store.dispatch('storekeepers_stocks/getFreightByTracking', this.tracking).then(freight => {
                    if (!freight) return;

                    this.freight = Object.assign({}, freight);
                    if (freight.currenttracking) this.currentTracking = Object.assign({}, freight.currenttracking);
                    else {
                        this.freightErrors.push('У груза не установленно текущее местоположение');
                        return;
                    }

                    this.form.stock_id = this.currentTracking.stock_id;
                    this.form.freight_id = freight.id;
                }).finally(() => this.loading = false);
            },
            getTrackingStatuses() {
                this.$store.dispatch('storekeepers_stocks/getTrackingStatuses', {
                    filter: {model: [['code', '=', 'storekeeper_issued_to_client']]}
                });
            },
            setDefaultTrackingStatus() {
                if (!this.freightsStatuses || !this.freightsStatuses.length) return;
                let status = this.freightsStatuses.find((item, i) => item.code === 'storekeeper_issued_to_client');
                this.$set(this.form, 'status_id', status.id);

                this.issuedStatus = Object.assign({}, status);
                this.form.status_id = status.id;
            },
            issue() {
              this.capture().then(() => {
                this.loading = true;
                this.$store.dispatch('stock/addFreightTracking', this.form).then(r => {
                  if (r) {
                    this.$store.commit('showSnackbar', ['Груз успешно выдан получателю', 6000, 'success']);
                    //Задача CRML-687 - сказали убрать автоматическую печать экспедиторской расписки
                    //this.printDoc(this.freight.deal_id, 'receipt');
                    this.$root.$emit('reload-table', 'storekeepers-freights-table');
                    this.$router.push({name: 'StorekeepersFreights'});
                  }
                  return r;
                }).finally(() => this.loading = false);
              }, () => alert('Ошибка подписи'));
            },
            printDoc(id, type) {
                let url = this.endpoint + '/print/' + type + '?deal_id=' + id + '&user_id=' + this.user.id
                window.open(url, '_blank');
            },
            checkDebt() {
                if (this.freight.deal && this.freight.deal.payer_id) {
                    this.debt.result = !!parseInt(this.freight.deal.payer.can_issue_freight);
                    /* Предыдущая логика, сейчас делать запрос не надо, актуальная задолжность находится в поле контранета debt, можно ли выдавать грузы в поле can_issue_freight
                    return this.$store.dispatch('finance/getDebt', { id: this.freight.deal.payer_id }).then(debt => {
                        if (!debt || !Object.keys(debt)) debt = {result: false};
                        this.debt = Object.assign({}, debt);
                    });
                    */
                } else {
                    this.freightErrors.push('У заявки не установлен плательщик, расчёт возможности выдачи невозможен.');
                    this.debt = {result: false};
                }
            }
        },
        created() {
            this.$nextTick(() => {
                this.$root.isAuth().then(
                    () => this.init(),
                    () => this.$router.push({name: 'Login'})
                );
                this.getTrackingStatuses();
                setTimeout(() => this.$refs.tracking.$el.focus(), 0);
                setTimeout(() => {
                    if (this.user && this.user.id) this.form.responsible_id = this.user.id;
                }, 200);
            });
        }
    }
</script>
<style lang="sass">
    .debt
        font-size: 14px
        .deny
            color: #d66565
        .allow
            color: #67d665
    .error
        color: #d66565
</style>



// WEBPACK FOOTER //
// IssueFreight.vue?828a7c2e